import ExceptionBase from "@/dto/exceptions/exceptionBase";
export default class UnauthorizedValidationException extends ExceptionBase {
  constructor(data) {
    super(data);
  }
}
